import React from "react";
import { getAllQueueTypeNames } from "lib/specialGameMode";
import { useSpecialTierList } from "./tierlistHooks";

export function useActiveSpecialModes() {
  const specialModes = getAllQueueTypeNames();
  const liveSpecialModes = [];
  for (let i = 0; i < specialModes.length; i++) {
    const { queueType, buildPageName } = specialModes[i];
    const options = { queueType, buildPageName };
    const { data, loading, error } = useSpecialTierList({
      customParams: options,
      ssr: true,
      skipURL: true,
    });

    if (data && !error) {
      liveSpecialModes.push(queueType);
    }
  }

  return liveSpecialModes;
}
